<template>
	<b-overlay :show="loading">
		<b-container class="mt-5 mb-5">
			<div class="row">
				<div class="col-12 mb-5">
					<b-img src="https://gnr.crashtag.com/logo.png" class="img-fluid mx-auto d-block" style="max-width: 250px;">
					</b-img>
				</div>
				<div class="col-12 text-center">
					<div class="row">
						<div class="col-6">
							<h4 class="text-right mt-2">Your Closest Crashtag Server:</h4>
						</div>
						<div class="col-2 text-center" v-if="userGeoIp.iso_code">
							<a :href="userGeoServer.production">
								<b-img-lazy width="100px" :src="getFlag(userGeoIp.iso_code.toLowerCase())" fluid></b-img-lazy>
								<p class="text-center pt-2">{{userGeoIp.iso_code}}</p>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col-8 offset-2 mt-5">
				<h4 class="text-center">Other Crashtag Locations</h4>
				<p class="text-center mt-3 mb-2">If you are in a different location to your closest server, or you need
					to
					sign into another country, click the flag below to log in to that location.</p>
			</div>
			<div class="col-12 mb-5">
				<div class="row">
					<div class="col-4 mt-3 text-center" v-for="(server, country) in countries" :key="country">
						<a :href="servers[server].production">
							<b-img-lazy :src="getFlag(country.toLowerCase())" class="img-fluid flag_image"></b-img-lazy>
							<br>
							<p class="country_text pt-2">{{ country }}</p>
						</a>
					</div>
				</div>
			</div>
			<footer class="fixed-bottom">
				<div class="container">
					<div class="col">
						<p class="text-center">
							Need help? Visit our help centre by
							<a href="https://crashtag.com/help-centre" target="_blank">clicking
								here</a> - or start a live chat with customer support by clicking on the support icon on
							the
							bottom right of screen.
						</p>
					</div>
				</div>
			</footer>

			<noscript><a href="https://www.livechatinc.com/chat-with/11934462/" rel="nofollow">Chat with us</a>, powered
				by
				<a
						href="https://www.livechatinc.com/?welcome" rel="noopener nofollow" target="_blank">LiveChat</a>
			</noscript>
		</b-container>
	</b-overlay>
</template>

<script>
	import axios from 'axios'

	export default {
		data() {
			return {
				userGeoIp: {
					iso_code: null
				},
				servers: [],
				countries: [],
				loading: true
			}
		},
		computed: {
			userGeoServer() {
				if (!this.userGeoIp.iso_code) {
					return null;
				}
				if (this.countries[this.userGeoIp.iso_code]) {
					return this.servers[this.countries[this.userGeoIp.iso_code]];
				}
				return this.servers.generic;
			}
		},
		methods: {
			getServers() {
				axios.get('https://gnr.crashtag.com/servers.json')
					.then((res) => {
						this.servers = res.data.servers;
						this.countries = res.data.countries;
					})
			},
			getGeoIp() {
				this.loading = true;
				axios.get('https://gnr.crashtag.com/api/v1/geoip', {headers: {'X-Platform': 'AimssSplash/1.0.0'}}).then((rsp) => {
					this.userGeoIp = rsp.data
					this.loading = false;
				})
			},
			getFlag(country) {
				if (country === 'uk') {
					country = 'gb';
				}

				return require('../node_modules/svg-country-flags/svg/' + country + '.svg')
			}
		},
		beforeMount() {

			this.getGeoIp()
			this.getServers()


			window.__lc = window.__lc || {};
			window.__lc.license = 11934462;
			(function (n, t, c) {
				function i(n) {
					return e._h ? e._h.apply(null, n) : e._q.push(n)
				}

				var e = {
					_q: [], _h: null, _v: "2.0", on: function () {
						i(["on", c.call(arguments)])
					}, once: function () {
						i(["once", c.call(arguments)])
					}, off: function () {
						i(["off", c.call(arguments)])
					}, get: function () {
						if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
						return i(["get", c.call(arguments)])
					}, call: function () {
						i(["call", c.call(arguments)])
					}, init: function () {
						var n = t.createElement("script");
						n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n)
					}
				};
				!n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e
			}(window, document, [].slice))
		},
	}
</script>

<style lang="scss">
	/*@import "~bootstrap/scss/variables";*/
	/*@import "~bootstrap/scss/functions";*/
	@import "~bootstrap/scss/bootstrap";
	//	@import "~bootstrap-vue/src/index";

	body {
		@import url('https://fonts.googleapis.com/css?family=Raleway:300,400,600";');
		color: #444E59;
	}

	.flag_image {
		height: 50px;
	}

	.country_text {
		color: #444E59;
	}
</style>
